import { Person } from '../../beans/Person';
import { PersonService } from '../../services/person.service';
import { Component, OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges, HostListener, ElementRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
	selector: 'app-frantishex-auto-completer',
	templateUrl: './frantishex-auto-completer.component.html',
	providers: [
		{ provide: NG_VALUE_ACCESSOR, useExisting: FrantishexAutoCompleterComponent, multi: true }
	],
	styleUrls: ['./frantishex-auto-completer.component.scss']
})
export class FrantishexAutoCompleterComponent implements OnInit, ControlValueAccessor {

	constructor(private personService: PersonService, private elementRef: ElementRef) { }

	ngOnInit() {
		this.objectList = new Array<any>();
	}

	@Input() placeholderName: string;
	@Input() countObjects: number;
	@Input() cleanOnSelect = false;
	selectedObject: any;

	@Output() onChange = new EventEmitter();
	@Output() onButtonClick: EventEmitter<any> = new EventEmitter();

	private onTouchedCallback: () => void = () => { };
	private onChangeCallback: (_: any) => void = () => { };


	ngOnChanges(changes: SimpleChanges) {
	}
	objectList: Array<any>;
	stringName: string;
	public canShow = false;

	changeString() {
		if (this.stringName.length == 0) {
			this.canShow = false;
		}
		if (this.stringName.length >= 3) {
			this.canShow = true;
			this.personService.searchPersons(this.stringName).subscribe(result => {
				console.log(this.countObjects);
				if (result.length > this.countObjects) {
					for (var i = 0; i < this.countObjects + 10; i++) {
						this.objectList[i] = result[i];
					}
				} else {
					this.objectList = result;
				}
			});
		}
	}

	writeValue(value: any): void {
		this.selectedObject = value;
		this.stringName = value ? value.name : '';
	}

	registerOnChange(fn: any) {
		this.onChangeCallback = fn;
	}
	toggleShow(show: boolean) {
		this.canShow = show;
	}
	registerOnTouched(fn: any) {
		this.onTouchedCallback = fn;
	}


	close() {
		this.clear();
		this.toggleShow(false);
		this.onButtonClick.emit();
	}

	onselectEvent(obj: any) {
		if (obj) {
			this.selectedObject = obj;
			this.stringName = obj.name;
			this.toggleShow(false);
			this.onChangeCallback(obj);   // вдигаме стойността към външния [(ngModel)]
			this.onChange.emit(obj);

			if (this.cleanOnSelect) {
				this.clear();
			}
		}
	}

	clear() {
		this.stringName = '';
		this.selectedObject = null;
		this.onChangeCallback(null);    // казваме на Angular, че стойността вече е null
		this.onChange.emit(null);
	}

	@HostListener('document:click', ['$event'])
	onDocumentClick(event: MouseEvent) {
		const clickedInside =
			this.elementRef.nativeElement.contains(event.target);

		if (!clickedInside) {
			this.canShow = false;
		}
	}

}



